import {Card} from '@material-ui/core'
import styled from 'styled-components'

export const TermsContainer = styled(Card)`
  position: relative;
  max-height: 300px;
  overflow: auto;
`

export const PageSwitcherContainer = styled.div`
  display: flex;
  margin: 10px 0;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`
